import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Row, Col, CardBody, Input, Button, FormGroup, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { isEmpty, reduce } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';
import { checkRole } from '../../helpers/Roles';
import IconCheckbox from '../../assets/images/icon-checkbox.png';
import IconCheckboxActive from '../../assets/images/icon-checkbox-active.png';
import IconArrowDown from '../../assets/images/ic_arrow_down.png';
import IconArrowUp from '../../assets/images/ic_arrow_up.png';
import AsyncSelect from "react-select/async";
import IconTooltip from '../../assets/images/icon-tooltip.png';
import ReactTooltip from 'react-tooltip';

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

const Modules = [
    {
        header: "Khám bệnh",
        pers: [
            'addDesignation', 'viewListDesignation', 'viewDesignation', 'editDesignation', 'deleteDesignation', 'statusDesignation',
            'printDesignation',
            'addConsultationMenu','viewListConsultationMenu','viewConsultationMenu','editConsultationMenu','deleteConsultationMenu','statusConsultationMenu','printConsultationMenu',
            'addExamination', 'viewListExamination', 'viewExamination', 'editExamination', 'deleteExamination', 'statusExamination', 'printExamination',
            'addMenu', 'viewMenu', 'editMenu', 'printMenu',
            'addMenuconsultation', 'viewListMenuconsultation', 'viewMenuconsultation', 'editMenuconsultation', 'printMenuconsultation',
            'addPrescription', 'viewListPrescription', 'viewPrescription', 'editPrescription', 'deletePrescription', 'printPrescription',
            'addWelcome', 'viewListWelcome', 'viewWelcome', 'editWelcome', 'deleteWelcome', 'statusWelcome',
            'addBooking', 'viewListBooking', 'viewBooking', 'editBooking', 'deleteBooking', 'statusBooking', "printReception",
            'statusAfterDoneExamination'
        ],
        data: [
            {
                title: 'Tiếp đón',
                is_bold: true,
                pers: [
                    'addWelcome', 'viewListWelcome', 'viewWelcome', 'editWelcome', 'deleteWelcome', 'statusWelcome',
                    'addBooking', 'viewListBooking', 'viewBooking', 'editBooking', 'deleteBooking', 'statusBooking', "printReception"
                ],
                data: [
                    {
                        title: 'Tiếp đón',
                        perKey: {
                            add: 'addWelcome',
                            viewList: 'viewListWelcome',
                            view: 'viewWelcome',
                            edit: 'editWelcome',
                            delete: 'deleteWelcome',
                            status: 'statusWelcome',
                            print: 'printReception',
                        }
                    },
                    {
                        title: 'Đặt lịch',
                        perKey: {
                            add: 'addBooking',
                            viewList: 'viewListBooking',
                            view: 'viewBooking',
                            edit: 'editBooking',
                            delete: 'deleteBooking',
                            status: 'statusBooking',
                        }
                    }
                ]
            },
            {
                title: 'Phiếu khám',
                pers: [
                    'addExamination', 'viewListExamination', 'viewExamination', 'editExamination', 'deleteExamination', 'statusExamination',
                    'addMenu', 'viewMenu', 'editMenu', 'printMenu',
                    'addMenuconsultation', 'viewListMenuconsultation', 'viewMenuconsultation', 'editMenuconsultation', 'printMenuconsultation',
                    'addPrescription', 'viewListPrescription', 'viewPrescription', 'editPrescription', 'deletePrescription', 'printPrescription', 'printExamination',
                    'statusAfterDoneExamination'
                ],
                is_bold: true,
                data: [
                    {
                        title: 'Thông tin khám',
                        perKey: {
                            add: 'addExamination',
                            viewList: 'viewListExamination',
                            view: 'viewExamination',
                            edit: 'editExamination',
                            delete: 'deleteExamination',
                            status: 'statusExamination',
                            print: 'printExamination',
                        }
                    },
                    {
                        title: 'Khai thác khẩu phàn ăn 24h',
                        perKey: {
                            add: 'addMenu',
                            view: 'viewMenu',
                            edit: 'editMenu',
                            print: 'printMenu',
                        }
                    },
                    {
                        title: 'Tư vấn thực đơn',
                        perKey: {
                            add: 'addMenuconsultation',
                            viewList: 'viewListMenuconsultation',
                            view: 'viewMenuconsultation',
                            edit: 'editMenuconsultation',
                            print: 'printMenuconsultation',
                        }
                    },
                    {
                        title: 'Kê đơn',
                        perKey: {
                            add: 'addPrescription',
                            viewList: 'viewListPrescription',
                            view: 'viewPrescription',
                            edit: 'editPrescription',
                            delete: 'deletePrescription',
                            print: 'printPrescription',
                        }
                    },
                    {
                        title: 'Thay đổi trạng thái phiếu khám Đã khám',
                        perKey: {
                            viewList: "statusAfterDoneExamination",
                        }
                    },
                    {
                        title: 'Hội chẩn',
                        perKey: {
                            add: 'addConsultation',
                            view: 'viewConsultation',
                            edit: 'editConsultation',
                            delete: 'deleteConsultation',
                            status: 'statusConsultation',
                            print: 'printConsultation'
                        }
                    },
                    {
                        title: 'Thiết lập huỷ phiếu',
                        perKey: {
                            view: 'viewConfigExaminationCancel',
                            edit: 'editConfigExaminationCancel'
                        }
                    },
                    {
                        title: 'Phê duyệt huỷ phiếu',
                        perKey: {
                            status: 'approveCancel'
                        }
                    },
                    {
                        title: 'Quản lý in phiếu',
                        perKey: {
                            add: 'addPrintedTicket',
                            viewList: 'viewListPrintedTicket',
                        }
                    },
                ]
            },
            {
                title: 'Thực đơn tư vấn',
                pers: [
                    'addConsultationMenu',
                    'viewListConsultationMenu',
                    'viewConsultationMenu',
                    'editConsultationMenu',
                    'deleteConsultationMenu',
                    'statusConsultationMenu',
                    'printConsultationMenu'
                ],
                is_bold: true,
                perKey: {
                    add: 'addConsultationMenu',
                    viewList: 'viewListConsultationMenu',
                    view: 'viewConsultationMenu',
                    edit: 'editConsultationMenu',
                    delete: 'deleteConsultationMenu',
                    status: 'statusConsultationMenu',
                    print: 'printConsultationMenu',
                }
            },
            {
                title: 'Dịch vụ chỉ định',
                pers: [
                    'addDesignation', 'viewListDesignation', 'viewDesignation', 'editDesignation', 'deleteDesignation', 'statusDesignation',
                    'printDesignation'
                ],
                is_bold: true,
                perKey: {
                    add: 'addDesignation',
                    viewList: 'viewListDesignation',
                    view: 'viewDesignation',
                    edit: 'editDesignation',
                    delete: 'deleteDesignation',
                    status: 'statusDesignation',
                    print: 'printDesignation',
                }
            },
        ]
    },
    {
        header: "Bán hàng",
        pers: [
            'addOrders', 'viewListOrders', 'viewOrders', 'editOrders', 'deleteOrders', 'statusOrders', 'printOrders',
            'addOrdersPOS', 'viewListOrdersPOS', 'viewOrdersPOS', 'printOrdersPOS',
        ],
        data: [
            {
                title: 'Đơn thuốc',
                is_bold: true,
                perKey: {
                    add: 'addOrders',
                    viewList: 'viewListOrders',
                    view: 'viewOrders',
                    edit: 'editOrders',
                    delete: 'deleteOrders',
                    status: 'statusOrders',
                    print: 'printOrders',
                }
            },
            {
                title: 'Bán hàng',
                is_bold: true,
                perKey: {
                    add: 'addOrdersPOS',
                    viewList: 'viewListOrdersPOS',
                    view: 'viewOrdersPOS',
                    print: 'printOrdersPOS',
                }
            },
            {
                title: 'Gói thẻ dịch vụ',
                is_bold: true,
                perKey: {
                    add: 'addOrderspackage',
                    viewList: 'viewListOrderspackage',
                    view: 'viewOrderspackage',
                    edit: 'editOrderspackage',
                    delete: 'deleteOrderspackage',
                    status: 'statusOrderspackage',
                    print: 'printOrderspackage'
                }
            },
        ]
    },
    {
        header: "Tài chính",
        pers: [
            'addReceipts', 'viewListReceipts', 'viewReceipts',
            'addPayment', 'viewListPayment', 'viewPayment', 'printReceipts'
        ],
        data: [
            {
                title: 'Phiếu thu',
                is_bold: true,
                perKey: {
                    add: 'addReceipts',
                    viewList: 'viewListReceipts',
                    view: 'viewReceipts',
                    print: 'printReceipts',
                }
            },
            {
                title: 'Phiếu chi',
                is_bold: true,
                perKey: {
                    add: 'addPayment',
                    viewList: 'viewListPayment',
                    view: 'viewPayment',
                }
            },
            {
                title: 'Sổ quỹ',
                is_bold: true,
                perKey: {
                    view: 'viewFundaccount',
                    debt: 'reportFundaccount'
                }
            }
        ]
    },
    {
        header: "Kho hàng",
        pers: [
            'addStockRequest', 'viewListStockRequest', 'viewStockRequest', 'editStockRequest', 'statusStockRequest',
            'addStockImport', 'viewListStockImport', 'viewStockImport', 'editStockImport', 'deleteStockImport', 'statusStockImport',
            'addStockTransfer', 'viewListStockTransfer', 'viewStockTransfer', 'editStockTransfer', 'deleteStockTransfer', 'statusStockTransfer',
            'addStockReturn', 'viewListStockReturn', 'viewStockReturn', 'editStockReturn', 'deleteStockReturn', 'statusStockReturn',
            'addStockCancel', 'viewListStockCancel', 'viewStockCancel', 'editStockCancel', 'deleteStockCancel', 'statusStockCancel',
        ],
        data: [
            {
                title: 'Phiếu yêu cầu nhập',
                is_bold: true,
                perKey: {
                    add: 'addStockRequest',
                    viewList: 'viewListStockRequest',
                    view: 'viewStockRequest',
                    edit: 'editStockRequest',
                    status: 'statusStockRequest',
                }
            },
            {
                title: 'Nhập hàng',
                is_bold: true,
                perKey: {
                    add: 'addStockImport',
                    viewList: 'viewListStockImport',
                    view: 'viewStockImport',
                    edit: 'editStockImport',
                    delete: 'deleteStockImport',
                    status: 'statusStockImport',
                }
            },
            {
                title: 'Chuyển kho',
                is_bold: true,
                perKey: {
                    add: 'addStockTransfer',
                    viewList: 'viewListStockTransfer',
                    view: 'viewStockTransfer',
                    edit: 'editStockTransfer',
                    delete: 'deleteStockTransfer',
                    status: 'statusStockTransfer',
                }
            },
            {
                title: 'Trả hàng',
                is_bold: true,
                perKey: {
                    add: 'addStockReturn',
                    viewList: 'viewListStockReturn',
                    view: 'viewStockReturn',
                    edit: 'editStockReturn',
                    delete: 'deleteStockReturn',
                    status: 'statusStockReturn',
                }
            },
            {
                title: 'Xuất hỏng hủy',
                is_bold: true,
                perKey: {
                    add: 'addStockCancel',
                    viewList: 'viewListStockCancel',
                    view: 'viewStockCancel',
                    edit: 'editStockCancel',
                    delete: 'deleteStockCancel',
                    status: 'statusStockCancel',
                }
            }
        ]
    },
    {
        header: "Sản phẩm",
        pers: [
            'addProduct', 'viewListProduct', 'viewProduct', 'editProduct', 'deleteProduct',
            'addProductBatch', 'viewListProductBatch', 'viewProductBatch', 'editProductBatch', 'deleteProductBatch',
            'addCategory', 'viewListCategory', 'viewCategory', 'editCategory', 'deleteCategory', 'statusCategory'
        ],
        data: [
            {
                title: 'Sản phẩm',
                is_bold: true,
                perKey: {
                    add: 'addProduct',
                    viewList: 'viewListProduct',
                    view: 'viewProduct',
                    edit: 'editProduct',
                    delete: 'deleteProduct',
                }
            },
            {
                title: 'Gói dịch vụ',
                is_bold: true,
                perKey: {
                    add: 'addServicepackage',
                    viewList: 'viewListServicepackage',
                    view: 'viewServicepackage',
                    edit: 'editServicepackage',
                    delete: 'deleteServicepackage',
                    status: 'statusServicepackage'
                }
            },
            {
                title: 'Lô sản phẩm',
                is_bold: true,
                perKey: {
                    add: 'addProductBatch',
                    viewList: 'viewListProductBatch',
                    view: 'viewProductBatch',
                    edit: 'editProductBatch',
                    delete: 'deleteProductBatch',
                }
            },
            {
                title: 'Danh mục',
                is_bold: true,
                perKey: {
                    add: 'addCategory',
                    viewList: 'viewListCategory',
                    view: 'viewCategory',
                    edit: 'editCategory',
                    delete: 'deleteCategory',
                    status: 'statusCategory',
                }
            }
        ]
    },
    {
        header: "Đối tác",
        pers: [
            'addCustomer', 'viewListCustomer', 'viewCustomer', 'editCustomer', 'deleteCustomer', 'statusCustomer',
            'addCustomergroup', 'viewListCustomergroup', 'viewCustomergroup', 'editCustomergroup', 'deleteCustomergroup',
            'addSupplier', 'viewListSupplier', 'viewSupplier', 'editSupplier', 'deleteSupplier', 'statusSupplier', 'debtCustomer', 'debtSupplier'
        ],
        data: [
            {
                title: 'Khách hàng',
                is_bold: true,
                perKey: {
                    add: 'addCustomer',
                    viewList: 'viewListCustomer',
                    view: 'viewCustomer',
                    edit: 'editCustomer',
                    delete: 'deleteCustomer',
                    status: 'statusCustomer',
                    debt: 'debtCustomer',
                }
            },
            {
                title: 'Nhóm Khách hàng',
                is_bold: true,
                perKey: {
                    add: 'addCustomergroup',
                    viewList: 'viewListCustomergroup',
                    view: 'viewCustomergroup',
                    edit: 'editCustomergroup',
                    delete: 'deleteCustomergroup',
                }
            },
            {
                title: 'Nhà cung cấp',
                is_bold: true,
                perKey: {
                    add: 'addSupplier',
                    viewList: 'viewListSupplier',
                    view: 'viewSupplier',
                    edit: 'editSupplier',
                    delete: 'deleteSupplier',
                    status: 'statusSupplier',
                    debt: 'debtSupplier',
                }
            }
        ]
    },
    {
        header: "Cấu hình",
        pers: [
            'addBranch', 'viewListBranch', 'viewBranch', 'editBranch', 'deleteBranch', 'statusBranch',
            'addUser', 'viewListUser', 'viewUser', 'editUser', 'statusUser',
            'addUsertitle', 'viewListUsertitle', 'viewUsertitle', 'editUsertitle', 'deleteUsertitle',
            'addUsergroup', 'viewListUsergroup', 'viewUsergroup', 'editUsergroup', 'deleteUsergroup', 'statusUsergroup',
            'addClinic', 'viewListClinic', 'viewClinic', 'editClinic', 'deleteClinic', 'statusClinic',
            'addService', 'viewListService', 'viewService', 'editService', 'deleteService', 'statusService',
            'addServicegroup', 'viewListServicegroup', 'viewServicegroup', 'editServicegroup', 'deleteServicegroup',
            'addTypeReceipts', 'viewListTypeReceipts', 'viewTypeReceipts', 'editTypeReceipts', 'deleteTypeReceipts',
            'viewTypeReceipts', 'editTypeReceipts', 'statusWorkTime',
            'addConclusion', 'viewListConclusion', 'viewConclusion', 'editConclusion', 'deleteConclusion', 'statusConclusion',
            'addFood', 'viewListFood', 'viewFood', 'editFood', 'deleteFood',
            'viewPriceCosstConfig', 'editPriceCosstConfig',
            'addSalesChannel', 'viewListSalesChannel', 'editSalesChannel', 'deleteSalesChannel', 'statusSalesChannel', 'viewSalesChannel',
            'viewCustomerRank', 'editCustomerRank', 'statusCustomerRank',
            'addRole', 'viewListRole', 'viewRole', 'editRole', 'deleteRole', 'statusRole',
            'addShippingPartner', 'viewListShippingPartner', 'viewShippingPartner', 'editShippingPartner', 'deleteShippingPartner', 'statusShippingPartner',
            'addPaymentMethod', 'viewListPaymentMethod', 'viewPaymentMethod', 'editPaymentMethod', 'deletePaymentMethod', 'statusPaymentMethod',
            'viewSheet', 'viewListSheet', 'addSheet', 'editSheet', 'deleteSheet', 'statusSheet',
            'viewShift', 'viewListShift', 'addShift', 'editShift', 'deleteShift', 'statusShift',
        ],
        data: [
            {
                title: 'Cớ ở khám/ Tư vấn',
                is_bold: true,
                perKey: {
                    add: 'addBranch',
                    viewList: 'viewListBranch',
                    view: 'viewBranch',
                    edit: 'editBranch',
                    delete: 'deleteBranch',
                    status: 'statusBranch',
                }
            },
            {
                title: 'Nhân viên',
                is_bold: true,
                perKey: {
                    add: 'addUser',
                    viewList: 'viewListUser',
                    view: 'viewUser',
                    edit: 'editUser',
                    status: 'statusUser',
                }
            },
            {
                title: 'Chức danh',
                is_bold: true,
                perKey: {
                    add: 'addUsertitle',
                    viewList: 'viewListUsertitle',
                    view: 'viewUsertitle',
                    edit: 'editUsertitle',
                    delete: 'deleteUsertitle',
                }
            },
            {
                title: 'Nhóm người dùng',
                is_bold: true,
                perKey: {
                    add: 'addUsergroup',
                    viewList: 'viewListUsergroup',
                    view: 'viewUsergroup',
                    edit: 'editUsergroup',
                    delete: 'deleteUsergroup',
                    status: 'statusUsergroup',
                }
            },
            {
                title: 'Phòng khám',
                is_bold: true,
                perKey: {
                    add: 'addClinic',
                    viewList: 'viewListClinic',
                    view: 'viewClinic',
                    edit: 'editClinic',
                    delete: 'deleteClinic',
                    status: 'statusClinic',
                }
            },
            {
                title: 'Dịch vụ',
                is_bold: true,
                perKey: {
                    add: 'addService',
                    viewList: 'viewListService',
                    view: 'viewService',
                    edit: 'editService',
                    delete: 'deleteService',
                    status: 'statusService',
                }
            },
            {
                title: 'Nhóm dịch vụ',
                is_bold: true,
                perKey: {
                    add: 'addServicegroup',
                    viewList: 'viewListServicegroup',
                    view: 'viewServicegroup',
                    edit: 'editServicegroup',
                    delete: 'deleteServicegroup',
                }
            },
            {
                title: 'Phiếu thu chi',
                is_bold: true,
                perKey: {
                    add: 'addTypeReceipts',
                    viewList: 'viewListTypeReceipts',
                    view: 'viewTypeReceipts',
                    edit: 'editTypeReceipts',
                    delete: 'deleteTypeReceipts',
                }
            },
            {
                title: 'Thời gian làm việc',
                is_bold: true,
                perKey: {
                    view: 'viewWorkTime',
                    edit: 'editWorkTime',
                    status: 'statusWorkTime',
                }
            },
            {
                title: 'Mẫu kết kuận',
                is_bold: true,
                perKey: {
                    add: 'addConclusion',
                    viewList: 'viewListConclusion',
                    view: 'viewConclusion',
                    edit: 'editConclusion',
                    delete: 'deleteConclusion',
                    status: 'statusConclusion',
                }
            },
            {
                title: 'Thực phẩm',
                is_bold: true,
                perKey: {
                    add: 'addFood',
                    viewList: 'viewListFood',
                    view: 'viewFood',
                    edit: 'editFood',
                    delete: 'deleteFood',
                }
            },
            {
                title: 'Cấu hình phương pháp tính giá vốn',
                is_bold: true,
                perKey: {
                    view: 'viewPriceCosstConfig',
                    edit: 'editPriceCosstConfig',
                }
            },
            {
                title: 'Cấu hình nâng cao',
                is_bold: true,
                data: [
                    {
                        title: 'Nguồn đơn hàng',
                        perKey: {
                            add: 'addSalesChannel',
                            viewList: 'viewListSalesChannel',
                            view: 'viewSalesChannel',
                            edit: 'editSalesChannel',
                            delete: 'deleteSalesChannel',
                            status: 'statusSalesChannel',
                        }
                    },
                    {
                        title: 'Đơn vị vận chuyển',
                        perKey: {
                            add: 'addShippingPartner',
                            viewList: 'viewListShippingPartner',
                            view: 'viewShippingPartner',
                            edit: 'editShippingPartner',
                            delete: 'deleteShippingPartner',
                            status: 'statusShippingPartner',
                        }
                    },
                    {
                        title: 'Hình thức thanh toán',
                        perKey: {
                            add: 'addPaymentMethod',
                            viewList: 'viewListPaymentMethod',
                            view: 'viewPaymentMethod',
                            edit: 'editPaymentMethod',
                            delete: 'deletePaymentMethod',
                            status: 'statusPaymentMethod',
                        }
                    },
                ]
            },
            {
                title: 'Cấu hình hạng thành viên',
                is_bold: true,
                perKey: {
                    view: 'viewCustomerRank',
                    edit: 'editCustomerRank',
                    status: 'statusCustomerRank',
                }
            },
            {
                title: 'Phân quyền',
                is_bold: true,
                perKey: {
                    add: 'addRole',
                    viewList: 'viewListRole',
                    view: 'viewRole',
                    edit: 'editRole',
                    delete: 'deleteRole',
                    status: 'statusRole',
                }
            },
            {
                title: 'Lịch làm việc',
                is_bold: true,
                perKey: {
                    add: 'addSheet',
                    viewList: 'viewListSheet',
                    view: 'viewSheet',
                    edit: 'editSheet',
                    delete: 'deleteSheet',
                    status: 'statusSheet',
                }
            },
            {
                title: 'Ca làm việc',
                is_bold: true,
                perKey: {
                    add: 'addShift',
                    viewList: 'addListShift',
                    view: 'viewShift',
                    edit: 'editShift',
                    delete: 'deleteShift',
                    status: 'statusShift',
                }
            },
            {
                title: 'Sổ quỹ',
                is_bold: true,
                perKey: {
                    add: 'addFundaccount',
                    viewList: 'viewListFundaccount',
                    view: 'viewFundaccount',
                    edit: 'editFundaccount',
                    delete: 'deleteFundaccount',
                    status: 'statusFundaccount'
                }
            }
        ]
    },
    {
        header: "Báo cáo",
        pers: [
            'overviewReport',
        ],
        data: [
            {
                title: 'Báo cáo tổng quan',
                is_bold: true,
                perKey: {
                    viewList: 'overviewReport',
                }
            }
        ]
    },
    {
        header: "Khác",
        pers: [
            'editAllSheet', 'statusAllSheet', 'managerAllSheet'
        ],
        data: [
            {
                title: 'Trạng thái hoạt động của bác sĩ',
                is_bold: true,
                perKey: {
                    edit: 'editAllSheet',
                    status: 'statusAllSheet',
                    debt: 'managerAllSheet'
                }
            }
        ]
    },
]
const PermissionTemplate: any = {
    'admin': [
        "viewListCustomer",
        "viewListCustomergroup",
        "addCustomergroup",
        "addSupplier",
        "viewSupplier",
        "editSupplier",
        "deleteSupplier",
        "deleteCustomer",
        "deleteCustomergroup",
        "statusCustomer",
        "statusSupplier",
        "deleteProductBatch",
        "editProductBatch",
        "viewProductBatch",
        "addProductBatch",
        "viewListProductBatch",
        "viewListSupplier",
        "addCustomer",
        "viewCustomer",
        "viewCustomergroup",
        "editCustomergroup",
        "editCustomer",
        "viewListWelcome",
        "viewListBooking",
        "addBooking",
        "viewWelcome",
        "addWelcome",
        "viewBooking",
        "editWelcome",
        "editBooking",
        "deleteBooking",
        "deleteWelcome",
        "statusBooking",
        "statusWelcome",
        "viewListExamination",
        "addExamination",
        "viewExamination",
        "editExamination",
        "deleteExamination",
        "statusExamination",
        "editMenu",
        "viewMenu",
        "addMenu",
        "addMenu",
        "viewMenu",
        "editMenu",
        "printMenu",
        "printMenu",
        "printPrescription",
        "printDesignation",
        "statusDesignation",
        "deleteDesignation",
        "deletePrescription",
        "editPrescription",
        "editDesignation",
        "viewDesignation",
        "viewPrescription",
        "addPrescription",
        "addDesignation",
        "addConsultationMenu",
        "viewListDesignation",
        "viewListPrescription",
        "viewListOrders",
        "addOrders",
        "viewOrders",
        "editOrders",
        "deleteOrders",
        "statusOrders",
        "printOrders",
        "printOrdersPOS",
        "viewOrdersPOS",
        "addOrdersPOS",
        "viewListOrdersPOS",
        "addReceipts",
        "viewReceipts",
        "viewPayment",
        "addPayment",
        "viewListPayment",
        "viewListReceipts",
        "addStockRequest",
        "viewStockRequest",
        "editStockRequest",
        "statusStockRequest",
        "viewListStockRequest",
        "viewListStockImport",
        "addStockImport",
        "viewStockImport",
        "editStockImport",
        "deleteStockImport",
        "statusStockImport",
        "statusStockTransfer",
        "deleteStockTransfer",
        "editStockTransfer",
        "viewStockTransfer",
        "addStockTransfer",
        "viewListStockTransfer",
        "viewListStockReturn",
        "addStockReturn",
        "viewStockReturn",
        "editStockReturn",
        "deleteStockReturn",
        "statusStockReturn",
        "statusStockCancel",
        "deleteStockCancel",
        "editStockCancel",
        "viewStockCancel",
        "addStockCancel",
        "viewListStockCancel",
        "viewListProduct",
        "addProduct",
        "viewProduct",
        "editProduct",
        "deleteProduct",
        "viewListCategory",
        "addCategory",
        "viewCategory",
        "editCategory",
        "deleteCategory",
        "statusCategory",
        "viewListBranch",
        "addBranch",
        "viewBranch",
        "deleteBranch",
        "statusBranch",
        "editBranch",
        "viewListUser",
        "addUser",
        "viewUser",
        "editUser",
        "statusUser",
        "deleteUsertitle",
        "editUsertitle",
        "viewUsertitle",
        "addUsertitle",
        "viewListUsertitle",
        "viewListUsergroup",
        "addUsergroup",
        "viewUsergroup",
        "editUsergroup",
        "deleteUsergroup",
        "statusUsergroup",
        "statusClinic",
        "statusService",
        "deleteClinic",
        "deleteService",
        "editService",
        "editClinic",
        "viewClinic",
        "addClinic",
        "viewListClinic",
        "viewListService",
        "addService",
        "viewService",
        "addServicegroup",
        "viewListServicegroup",
        "viewServicegroup",
        "editServicegroup",
        "deleteServicegroup",
        "deleteTypeReceipts",
        "editTypeReceipts",
        "viewTypeReceipts",
        "addTypeReceipts",
        "viewListTypeReceipts",
        "viewTypeReceipts",
        "editTypeReceipts",
        "statusWorkTime",
        "statusConclusion",
        "deleteConclusion",
        "editConclusion",
        "viewConclusion",
        "addConclusion",
        "viewListConclusion",
        "viewListFood",
        "addFood",
        "viewFood",
        "editFood",
        "deleteFood",
        "editPriceCosstConfig",
        "viewPriceCosstConfig",
        "viewListSalesChannel",
        "viewSalesChannel",
        "addSalesChannel",
        "editSalesChannel",
        "deleteSalesChannel",
        "statusSalesChannel",
        "statusShippingPartner",
        "deleteShippingPartner",
        "editShippingPartner",
        "viewShippingPartner",
        "addShippingPartner",
        "viewListShippingPartner",
        "viewListPaymentMethod",
        "addPaymentMethod",
        "viewPaymentMethod",
        "editPaymentMethod",
        "deletePaymentMethod",
        "statusPaymentMethod",
        "statusCustomerRank",
        "deleteRole",
        "editRole",
        "editCustomerRank",
        "statusRole",
        "viewCustomerRank",
        "viewRole",
        "addRole",
        "viewListRole"
    ],
    'accountant': [
        "viewListWelcome",
        "viewListBooking",
        "viewMenu",
        "viewPrescription",
        "viewListPrescription",
        "viewDesignation",
        "viewListDesignation",
        "viewListOrders",
        "viewListOrdersPOS",
        "addOrdersPOS",
        "addOrders",
        "viewOrders",
        "viewOrdersPOS",
        "statusOrders",
        "viewListReceipts",
        "viewListPayment",
        "addPayment",
        "addReceipts",
        "viewReceipts",
        "viewPayment",
        "viewListStockRequest",
        "viewStockRequest",
        "viewListCustomer",
        "viewCustomer",
        "viewListCustomergroup",
        "viewCustomergroup",
        "viewListSupplier",
        "viewSupplier",
        "viewListStockImport",
        "addStockRequest",
        "editStockRequest",
        "statusStockRequest",
        "statusStockImport",
        "deleteStockImport",
        "editStockImport",
        "viewStockImport",
        "addStockImport",
        "viewListStockTransfer",
        "addStockTransfer",
        "viewStockTransfer",
        "deleteStockTransfer",
        "statusStockTransfer",
        "editStockTransfer",
        "viewListStockReturn",
        "viewListStockCancel",
        "addStockCancel",
        "addStockReturn",
        "viewStockReturn",
        "viewStockCancel",
        "editStockCancel",
        "editStockReturn",
        "deleteStockReturn",
        "deleteStockCancel",
        "statusStockCancel",
        "statusStockReturn",
        "viewListProduct",
        "viewProduct",
        "viewListProductBatch",
        "viewProductBatch",
        "viewCategory",
        "viewListCategory",
        "viewListBranch",
        "viewBranch",
        "viewListClinic",
        "viewClinic",
        "viewListService",
        "viewListServicegroup",
        "addServicegroup",
        "addService",
        "viewService",
        "viewServicegroup",
        "editServicegroup",
        "editService",
        "deleteService",
        "deleteServicegroup",
        "statusService",
        "viewListTypeReceipts",
        "addTypeReceipts",
        "viewTypeReceipts",
        "editTypeReceipts",
        "deleteTypeReceipts",
        "viewTypeReceipts",
        "viewListSalesChannel",
        "viewListPaymentMethod",
        "viewListShippingPartner",
        "addSalesChannel",
        "addShippingPartner",
        "addPaymentMethod",
        "viewPaymentMethod",
        "viewShippingPartner",
        "viewSalesChannel",
        "editSalesChannel",
        "editShippingPartner",
        "editPaymentMethod",
        "deletePaymentMethod",
        "deleteShippingPartner",
        "deleteSalesChannel",
        "statusSalesChannel",
        "statusShippingPartner",
        "statusPaymentMethod"
    ],
    'user': [
        "viewListWelcome",
        "viewListBooking",
        "addBooking",
        "addWelcome",
        "viewWelcome",
        "editBooking",
        "editWelcome",
        "viewBooking",
        "deleteWelcome",
        "deleteBooking",
        "statusBooking",
        "statusWelcome",
        "viewListExamination",
        "addExamination",
        "viewExamination",
        "editExamination",
        "deleteExamination",
        "statusExamination",
        "viewMenu",
        "viewListPrescription",
        "viewPrescription",
        "viewDesignation",
        "viewListDesignation",
        "viewListConsultationMenu",
        "viewListOrders",
        "viewListOrdersPOS",
        "viewOrdersPOS",
        "viewOrders",
        "viewListReceipts",
        "viewListPayment",
        "addPayment",
        "addReceipts",
        "viewReceipts",
        "viewPayment",
        "viewListCustomer",
        "viewCustomer",
        "viewListSupplier",
        "viewSupplier",
        "viewListStockRequest",
        "viewStockRequest",
        "viewListStockImport",
        "viewStockImport",
        "viewStockTransfer",
        "viewListStockTransfer",
        "viewListStockReturn",
        "viewStockReturn",
        "viewStockCancel",
        "viewListStockCancel",
        "viewListProduct",
        "viewProduct",
        "viewProductBatch",
        "viewListProductBatch",
        "viewListCategory",
        "viewCategory",
        "viewListBranch",
        "viewBranch",
        "viewUser",
        "viewListUser",
        "viewListUsertitle",
        "viewUsertitle",
        "viewListUsergroup",
        "viewListClinic",
        "viewListService",
        "viewService",
        "viewClinic",
        "viewUsergroup",
        "viewServicegroup",
        "viewListServicegroup",
        "viewListTypeReceipts",
        "viewTypeReceipts",
        "viewTypeReceipts",
        "viewConclusion",
        "viewListConclusion",
        "viewListFood",
        "viewFood",
        "viewPriceCosstConfig",
        "viewSalesChannel",
        "viewListSalesChannel",
        "viewListShippingPartner",
        "viewShippingPartner",
        "viewListPaymentMethod",
        "viewListRole",
        "viewRole",
        "viewCustomerRank",
        "viewPaymentMethod",
    ]
}

const Detail: React.FC<Props> = (props: Props) => {
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props.match.params.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState<any>({
        name: "",
        description: "",
        template: "",
        permissions: [],
        status: 1
    });
    const [modalIsOpen, setIsOpen] = useState(false);
    const [permissions, setPermissions] = useState<any>([]);
    const [type, setType] = useState(props.match.params.action);
    const [action, setAction] = useState();
    const [users, setUsers] = useState();

    useEffect(() => {
        if (id && id !== 'add') {
            loadData(id)
            document.title = 'Chỉnh sửa nhóm quyền'

        } else {
            document.title = 'Thêm mới nhóm quyền'
        }
        if (type === 'view') {
            setOnlyView(true)
            document.title = 'Chi tiết nhóm quyền'
        }
    }, [id]);

    useEffect(() => {
        ReactTooltip.rebuild();
    });


    useEffect(() => {
        loadInit()
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const loadInit = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 200,
        }
        const [
            responseUser,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/user`, {
                ...params,
            }),
        ]);
        if (responseUser.response?.data !== undefined) {
            let ListArr: any = [];
            responseUser.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: `${e?.code || ''} ${e?.name}`,
                })
            })
            setUsers(ListArr)
        }
    }

    const loadData = async (id: number) => {
        const url = `${baseUrl}/roles/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const users = resData?.users?.reduce((prev: any, item: any) => {
                prev = [...prev, {
                    ...item,
                    value: item?.id,
                    label: item?.name
                }];
                return prev
            }, [])
            setData({
                ...resData,
                users
            })
            setPermissions(resData?.permissions)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: `${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} nhóm quyền`, active: true },
                ]}
                title={`${type == 'view' ? 'Xem chi tiết' : id ? 'Chỉnh sửa' : 'Thêm mới'} nhóm quyền`}
            />
            <ContentPage
                data={data}
                setData={(val: any) => setData(val)}
                onlyView={onlyView}
                id={id}
                type={type}
                action={action}
                handleActionModal={(data: any) => handleActionModal(data)}
                permissions={permissions}
                setPermissions={setPermissions}
                users={users}
            />
            <ReactTooltip id='rank-tooltip' type='info' />
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} users={users} setData={(val: any) => setData(val)} />
            </ModalPopup>
            {loading && <Loader />}
        </React.Fragment>
    );
};

const ContentPage = (props: any) => {
    const { data, type, setData, roles, users, usergroup, onlyView, id, action, handleActionModal, setPermissions, permissions } = props
    const [loading, setLoading] = useState(false)
    const router = useHistory()
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        setData({
            ...data,
            [name]: value
        })
    }
    const [loadingStockUser, setLoadingStockUser] = useState(false);
    const [queryStockUser, setQueryStockUser] = useState('')

    const handleInputChangeStockUser = (newValue: any) => {
        setQueryStockUser(newValue);
        return newValue;
    };

    const loadStockUser = async () => {
        setLoadingStockUser(true)
        let response: any = await APIClient.GET(`${baseUrl}/user`, {
            page: 1,
            limit: 100,
            name: queryStockUser
        });
        setLoadingStockUser(false)
        if (response.response?.data !== undefined) {
            const ListArr = response.response?.data?.reduce((prev: any, item: any) => {
                prev = [...prev,
                {
                    ...item,
                    label: `${item?.code || ''} ${item?.name}`,
                    value: item?.id
                }
                ]
                return prev
            }, [])
            return ListArr
        } else {
            return []
        }
    };

    const validationFrom = () => {

        if (isEmpty(data.name)) {
            toast.warning('Tên nhóm quyền không được để trống!');
            return false
        }

        return true
    }

    const handleSubmit = async () => {
        const newpermissions = permissions?.reduce((prev: any, item: any) => {
            if (item) prev = [...prev, item]
            return prev
        }, [])
        const newUsers = data?.users?.reduce((prev: any, item: any) => {
            if (item) prev = [...prev, item?.id]
            return prev
        }, [])
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/roles`;
        const params = {
            name: data?.name,
            template: data?.template,
            permissions: newpermissions,
            description: data?.description,
            users: newUsers,
            status: data?.status,
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới nhóm quyền thành công')
            router?.push('/setting/roles/list')
        }
    }

    const handleEdit = async () => {
        const newpermissions = permissions?.reduce((prev: any, item: any) => {
            if (item) prev = [...prev, item]
            return prev
        }, [])
        const newUsers = data?.users?.reduce((prev: any, item: any) => {
            if (item) prev = [...prev, item?.id]
            return prev
        }, [])
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/roles/${id}`;
        const params = {
            name: data?.name,
            template: data?.template,
            permissions: newpermissions,
            description: data?.description,
            users: newUsers,
            status: data?.status,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chỉnh sửa nhóm quyền thành công')
            router?.push('/setting/roles/list')
        }
    }

    return (
        <PageContent className={onlyView ? 'only-view pb-4' : 'pb-4'}>
            <Row>
                <Col md={8} className='pb-4'>
                    <PageBody>
                        <div className="nutri-title mb-3">{type === 'view' ? <>{data?.name} <span className='text-success'>({data?.users?.length} người)</span></> : "Chọn Quyền"}</div>
                        <div className="table-responsive" style={{ maxHeight: 650, overflow: 'auto' }}>
                            <table className="mb-0 table-custom no-bg table table-input responsive th-custom">
                                <thead>
                                    <tr>
                                        <th className="text-center sticky-position" style={{ width: '25%' }}></th>
                                        <th className="text-center sticky-position" style={{ width: 90 }}>Xem danh sách</th>
                                        <th className="text-center sticky-position" style={{ width: 80 }}>Tạo mới</th>
                                        <th className="text-center sticky-position" style={{ width: 80 }}>Xem chi tiết</th>
                                        <th className="text-center sticky-position" style={{ width: 80 }}>Chỉnh sửa</th>
                                        <th className="text-center sticky-position" style={{ width: 80 }}>Hủy/Xóa</th>
                                        <th className="text-center sticky-position" style={{ width: 100 }}>Thay đổi trạng thái</th>
                                        <th className="text-center sticky-position" style={{ width: 80 }}>In</th>
                                        <th className="text-center sticky-position" style={{ width: 80 }}>Khác</th>
                                    </tr>
                                </thead>
                                <tbody className='' style={{ height: '500px !important' }}>
                                    {Modules?.map((item: any, index: number) => {
                                        return (
                                            <RenderItemPermissions keyPer={`per-${index}`} key={`per-${index}`} item={item} level={index + 1} setPermissions={setPermissions} permissions={permissions} type={type} />
                                        )
                                    })}
                                </tbody>
                            </table>

                        </div>
                    </PageBody>
                </Col>
                <Col md={4}>
                    <PageBody>
                        <div className="nutri-title mb-3">Thông tin nhóm quyền</div>
                        <Row>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Tên nhóm quyền</Label>
                                    <Input type="text" value={data?.name} onChange={(e: any) => handleChangeInput(e)} name="name" placeholder="Nhập tên nhóm quyền" />
                                </FormGroup>
                            </Col>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <div className='mr-2'>Nhóm quyền mẫu </div>
                                        <div
                                            data-for="rank-tooltip"
                                            data-tip={"Nhóm quyền mẫu là các nhóm quyền đã được hệ thống chọn sẵn các quyền"}
                                        >
                                            <img src={IconTooltip} width={16} alt="icon" />
                                        </div>
                                    </Label>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <div className="nutri-checkbox" onClick={() => {
                                            if (type == 'view') return
                                            const templateValue = data?.template === 'admin' ? '' : 'admin'
                                            handleChangeInput({ target: { name: "template", value: templateValue } })
                                            const template: any[] = PermissionTemplate && PermissionTemplate[templateValue]
                                            if (template) {
                                                setPermissions([...template])
                                            }
                                        }}>
                                            <div className="icon">
                                                {data?.template === 'admin' ?
                                                    <img src={IconCheckboxActive} alt="icon" /> :
                                                    <img src={IconCheckbox} alt="icon" />
                                                }
                                            </div>
                                            <div className="label">Admin</div>
                                        </div>
                                        <div className="nutri-checkbox" onClick={() => {
                                            if (type == 'view') return
                                            const templateValue = data?.template === 'accountant' ? '' : 'accountant'
                                            handleChangeInput({ target: { name: "template", value: templateValue } })
                                            const template: any[] = PermissionTemplate && PermissionTemplate[templateValue]
                                            if (template) {
                                                setPermissions([...template])
                                            }
                                        }}>
                                            <div className="icon">
                                                {data?.template === 'accountant' ?
                                                    <img src={IconCheckboxActive} alt="icon" /> :
                                                    <img src={IconCheckbox} alt="icon" />
                                                }
                                            </div>
                                            <div className="label">Kế toán</div>
                                        </div>
                                        <div className="nutri-checkbox" onClick={() => {
                                            if (type == 'view') return
                                            const templateValue = data?.template === 'user' ? '' : 'user'
                                            handleChangeInput({ target: { name: "template", value: templateValue } })
                                            const template: any[] = PermissionTemplate && PermissionTemplate[templateValue]
                                            if (template) {
                                                setPermissions([...template])
                                            }
                                        }}>
                                            <div className="icon">
                                                {data?.template === 'user' ?
                                                    <img src={IconCheckboxActive} alt="icon" /> :
                                                    <img src={IconCheckbox} alt="icon" />
                                                }
                                            </div>
                                            <div className="label">Nhân viên</div>
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Ghi chú</Label>
                                    <TextareaAutosize disabled={type === 'view'} className={type === 'view' ? 'pointer' : ''} minRows={2} maxRows={8} value={data?.description || ''} onChange={(e: any) => handleChangeInput(e)} name="description" placeholder="Nhập ghi chú" />
                                </FormGroup>
                            </Col>
                        </Row>
                    </PageBody>
                    <PageBody className="only-view">
                        <div className="nutri-title mb-3">Phân quyền</div>
                        <Row>
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form' style={{ cursor: 'pointer' }} onClick={() => {
                                    if (type === 'view') return
                                    props?.handleActionModal({ type: 'addUser', data: data })
                                }}>
                                    <Label>Phân quyền</Label>
                                    {!data?.users ? <ValueText className='only-view'>Chưa chọn nhân viên nào</ValueText> :
                                        <AsyncSelect
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            onInputChange={handleInputChangeStockUser}
                                            loadOptions={loadStockUser}
                                            inputValue={queryStockUser}
                                            placeholder={loadingStockUser ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                                            noOptionsMessage={() => queryStockUser ? "Không tìm thấy dữ liệu" : 'Nhập tên, mã nhân viên'}
                                            loadingMessage={() => 'searching...'}
                                            styles={customStyles}
                                            cacheOptions
                                            defaultOptions={users}
                                            onChange={(val: any) => {
                                                handleChangeInput({ target: { value: val, name: 'users' } })
                                            }}
                                            value={data?.users}
                                            isMulti
                                            isDisabled={true}
                                        />}
                                </FormGroup>
                            </Col>
                        </Row>
                    </PageBody>
                </Col>
            </Row>
            <div className="bottom-action">
                <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                {
                    !id && <Button color="success" className='ml-2' onClick={handleSubmit}>Lưu lại</Button>
                }
                {
                    id && type == 'view' &&
                    <>
                        <Button color="success" className='danger-bland ml-2' onClick={() => props?.handleActionModal({ type: 'delete', data: data })}>Xóa</Button>
                        <Button color="success" className='ml-2' onClick={() => router?.push(`/setting/roles/${id}`)}>Chỉnh sửa</Button>
                    </>
                }
                {
                    id && type != 'view' &&
                    <Button color="success" className='ml-2' onClick={handleEdit}>Lưu lại</Button>
                }
            </div>
            {loading && <Loader />}
        </PageContent>
    )
}

const RenderPadding = (props: any) => {
    const level: any = `${props.level}`
    // const levelArray = level && level?.split(".")
    const levelArray = level && level?.split(".")
    return (
        <>
            {levelArray?.map((item: any, index: any) => (
                <span className='pl-2' key={`padding-${index}`}></span>
            ))}
        </>
    )
}

const RenderShowMore = ({ show, setShow }: any) => {
    return (
        <div className='sub-count-action ml-2' onClick={() => setShow(!show)}>
            <img style={{ border: 'none' }} src={show ? IconArrowUp : IconArrowDown} width={20} height={20} alt="" />
        </div>
    )
}

const RenderItemPermissions = ({ item, keyPer, level, setPermissions, permissions, type }: any) => {
    const [show, setShow] = useState(true)
    const perKey = item?.perKey
    return (
        <>
            {item?.header ?
                <tr>
                    <td colSpan={9} className='text-success'>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            <RenderPadding level={level} />
                            {item?.pers && <>
                                <RenderToggerPermissionsAll pers={item?.pers} setPermissions={setPermissions} permissions={permissions} type={type} />
                            </>}
                            <b>{item?.header}</b>
                            {item?.data && <RenderShowMore show={show} setShow={setShow} />}
                        </div>
                    </td>
                </tr> :
                item?.title && !item?.perKey ?
                    <tr><td colSpan={9} className={item?.is_bold ? 'font-weight-bold' : ''}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            <RenderPadding level={level} />
                            {item?.pers && <>
                                <RenderToggerPermissionsAll pers={item?.pers} setPermissions={setPermissions} permissions={permissions} type={type} />
                            </>}
                            {item?.title}
                            {item?.data && <RenderShowMore show={show} setShow={setShow} />}
                        </div>
                    </td></tr> :
                    item?.perKey ?
                        <tr>
                            <td className={item?.is_bold ? 'font-weight-bold' : ''}>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                    <RenderPadding level={level} />
                                    {item?.pers && <>
                                        <RenderToggerPermissionsAll pers={item?.pers} setPermissions={setPermissions} permissions={permissions} type={type} />
                                    </>}
                                    {item?.title}
                                </div>
                            </td>
                            <td className='text-center'>{perKey?.viewList && <RenderToggerPermissions perKey={perKey?.viewList} setPermissions={setPermissions} permissions={permissions} type={type} />}</td>
                            <td className='text-center'>{perKey?.add && <RenderToggerPermissions perKey={perKey?.add} setPermissions={setPermissions} permissions={permissions} type={type} />}</td>
                            <td className='text-center'>{perKey?.view && <RenderToggerPermissions perKey={perKey?.view} setPermissions={setPermissions} permissions={permissions} type={type} />}</td>
                            <td className='text-center'>{perKey?.edit && <RenderToggerPermissions perKey={perKey?.edit} setPermissions={setPermissions} permissions={permissions} type={type} />}</td>
                            <td className='text-center'>{perKey?.delete && <RenderToggerPermissions perKey={perKey?.delete} setPermissions={setPermissions} permissions={permissions} type={type} />}</td>
                            <td className='text-center'>{perKey?.status && <RenderToggerPermissions perKey={perKey?.status} setPermissions={setPermissions} permissions={permissions} type={type} />}</td>
                            <td className='text-center'>{perKey?.print && <RenderToggerPermissions perKey={perKey?.print} setPermissions={setPermissions} permissions={permissions} type={type} />}</td>
                            <td className='text-center'>
                                {(perKey?.debt == 'debtCustomer' || perKey?.debt == 'debtSupplier') ?
                                    <span><RenderToggerPermissions perKey={perKey?.debt} setPermissions={setPermissions} permissions={permissions} type={type} /> Công nợ</span>
                                    : perKey?.debt == 'reportFundaccount' ?
                                        <span><RenderToggerPermissions perKey={perKey?.debt} setPermissions={setPermissions} permissions={permissions} type={type} /> BC sổ quỹ</span>
                                        : perKey?.debt == 'managerAllSheet' ?
                                            <span><RenderToggerPermissions perKey={perKey?.debt} setPermissions={setPermissions} permissions={permissions} type={type} /> Quản lí</span>
                                            : null
                                }
                            </td>
                        </tr> :
                        <tr><td colSpan={8}></td></tr>
            }
            {show && item?.data?.map((itemSub: any, indexSub: number) => (
                <RenderItemPermissions keyPer={`${keyPer}-${indexSub}`} key={`${keyPer}-${indexSub}`} item={itemSub} level={`${level}.${(indexSub + 1)}`} setPermissions={setPermissions} permissions={permissions} type={type} />
            ))}
        </>
    )
}

const RenderToggerPermissions = ({ perKey, setPermissions, permissions, type }: any) => {
    const [status, setStatus] = useState(false)

    useEffect(() => {
        const index = permissions.indexOf(perKey);
        if (index > -1) {
            setStatus(true)
        } else {
            setStatus(false)
        }

    }, [permissions])
    const handleChangeCheckbox = (status: any) => {
        if (type === 'view') return
        setStatus(status)
        if (status) {
            if (perKey == 'managerAllSheet') {
                let updatedPermissions = [...permissions];
                if (permissions.indexOf('editAllSheet') == -1) {
                    updatedPermissions.push('editAllSheet');
                }
                if (permissions.indexOf('statusAllSheet') == -1) {
                    updatedPermissions.push('statusAllSheet');
                }
                updatedPermissions.push(perKey);
                setPermissions(updatedPermissions);
                return
            }
            setPermissions([
                ...permissions, perKey
            ])
        } else {
            const index = permissions.indexOf(perKey);
            if (index > -1) {
                permissions.splice(index, 1);
            }
            setPermissions([...permissions])
        }
    }
    return (
        <div className="nutri-checkbox" style={{ justifyContent: 'center' }} onClick={() => handleChangeCheckbox(!status)}>
            <div className="icon">
                {status ?
                    <img src={IconCheckboxActive} alt="icon" width={20} /> :
                    <img src={IconCheckbox} alt="icon" width={20} />
                }
                {/* {perKey == "printExamination" && <div style={{fontWeight: "bold", width: 40}}>BCYT</div>} */}
            </div>
        </div>
    )
}

const RenderToggerPermissionsAll = ({ pers, setPermissions, permissions, type }: any) => {
    const [status, setStatus] = useState(false)

    useEffect(() => {
        if (permissions?.some((itemPer: any) => !!pers?.find((item: any) => item === itemPer))) {
            setStatus(true)
        } else {
            setStatus(false)
        }

    }, [permissions])
    const handleChangeCheckbox = (status: any) => {
        if (type === 'view') return
        setStatus(status)
        if (status) {
            setPermissions([
                ...permissions, ...pers
            ])
        } else {
            const newpermissions = permissions?.reduce((prev: any, item: any) => {
                const indexOf = pers.indexOf(item);
                if (indexOf === -1) {
                    prev = [...prev, item]
                }
                return prev
            }, [])
            setPermissions([...newpermissions])
        }
    }
    return (
        <div className="nutri-checkbox" style={{ justifyContent: 'center' }} onClick={() => handleChangeCheckbox(!status)}>
            <div className="icon">
                {status ?
                    <img src={IconCheckboxActive} alt="icon" width={20} /> :
                    <img src={IconCheckbox} alt="icon" width={20} />
                }
            </div>
        </div>
    )
}

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData, users } = props
    const [loadingStockUser, setLoadingStockUser] = useState(false);
    const [queryStockUser, setQueryStockUser] = useState('')
    const [data, setData] = useState(action?.data?.users)

    const handleInputChangeStockUser = (newValue: any) => {
        setQueryStockUser(newValue);
        return newValue;
    };

    const loadStockUser = async () => {
        setLoadingStockUser(true)
        let response: any = await APIClient.GET(`${baseUrl}/user`, {
            page: 1,
            limit: 100,
            name: queryStockUser
        });
        setLoadingStockUser(false)
        if (response.response?.data !== undefined) {
            const ListArr = response.response?.data?.reduce((prev: any, item: any) => {
                prev = [...prev,
                {
                    ...item,
                    label: `${item?.code || ''} ${item?.name}`,
                    value: item?.id
                }
                ]
                return prev
            }, [])
            return ListArr
        } else {
            return []
        }
    };

    const handleDelete = async () => {
        setLoading(true)
        const url = `${baseUrl}/roles/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa nhóm quyền thành công')
            closeModal();
            loadData()
        }
    }

    const handleChangeUser = async () => {
        props?.setData({
            ...action?.data,
            users: data
        })
        closeModal();
    }

    if (!checkRole(props?.user?.roles, ['userEdit'], props?.user?.role)) {
        return (
            <CardBody className='p-0' style={{ width: 460 }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{ textAlign: 'center', width: '100%' }}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>

        )
    }

    return (
        <CardBody className='p-0' style={{ width: action?.type === 'addUser' ? 600 : 400 }}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {action?.type === 'delete' && "Xóa nhóm quyền"}
                    {action?.type === 'addUser' && "Phân quyền"}
                </h5>
                <button onClick={() => closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body ">
                {action?.type === 'delete' &&
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{ textAlign: 'center', width: '100%' }}>
                                Bạn có chắc chắn muốn xóa nhóm quyền <br /><b>{action?.data?.name}</b><br />
                            </p>
                        </FormGroup>
                    </Col>}
                {action?.type === 'addUser' &&
                    <>
                        <Col md={12} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label><span>*</span>Nhóm quyền</Label>
                                <ValueText className='only-view'>{action?.data?.name}</ValueText>
                            </FormGroup>
                        </Col>
                        <Col md={12} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Phân quyền</Label>
                                <AsyncSelect
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    onInputChange={handleInputChangeStockUser}
                                    loadOptions={loadStockUser}
                                    inputValue={queryStockUser}
                                    placeholder={loadingStockUser ? "Đang tải dữ liệu..." : "Nhập tên, mã..."}
                                    noOptionsMessage={() => queryStockUser ? "Không tìm thấy dữ liệu" : 'Nhập tên, mã nhân viên'}
                                    loadingMessage={() => 'searching...'}
                                    styles={customStyles}
                                    cacheOptions
                                    defaultOptions={users}
                                    onChange={(val: any) => {
                                        setData(val)
                                    }}
                                    value={data}
                                    isMulti
                                />
                            </FormGroup>
                        </Col>
                    </>
                }
            </div>
            <div className="modal-footer">
                <Button
                    onClick={() => {
                        action?.type === 'delete' && handleDelete()
                        action?.type === 'addUser' && handleChangeUser()
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const customStyles = {
    menuList: (base: any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};
export default connect(mapState)(Detail)